import {html, LitElement} from 'lit';
import {styleMap} from 'lit/directives/style-map.js';
import styles from './g-loading-overlay.component.scss';
import loadingSvg from 'scss/loading.svg';

export default class GenesisLoadingOverlay extends LitElement {
	static styles = [styles];

	constructor () {
		super();

	}

	render () {
		const overlayStyles = {
			background: `url(${loadingSvg})`
		};

		return html`
			<div class="g-loading-overlay">
				<div class="g-loading" style="${styleMap(overlayStyles)}"></div>
			</div>
		`;
	}
};
